/* This file is auto-generated with figma-svg. */
import hoc from '@hh.ru/magritte-ui-icon/hoc';
import { CheckboxCheckSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/private/CheckboxCheckSize16';
import { CheckboxCheckSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/private/CheckboxCheckSize24';
import { CheckboxLineSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/private/CheckboxLineSize16';
import { CheckboxLineSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/private/CheckboxLineSize24';
import { Diagram100Size16Glyph } from '@hh.ru/magritte-ui-icon/variants/private/Diagram100Size16';
import { Diagram100Size24Glyph } from '@hh.ru/magritte-ui-icon/variants/private/Diagram100Size24';
import { Diagram60Size16Glyph } from '@hh.ru/magritte-ui-icon/variants/private/Diagram60Size16';
import { Diagram60Size24Glyph } from '@hh.ru/magritte-ui-icon/variants/private/Diagram60Size24';
import { Diagram75Size16Glyph } from '@hh.ru/magritte-ui-icon/variants/private/Diagram75Size16';
import { Diagram75Size24Glyph } from '@hh.ru/magritte-ui-icon/variants/private/Diagram75Size24';
import { Diagram80Size16Glyph } from '@hh.ru/magritte-ui-icon/variants/private/Diagram80Size16';
import { Diagram80Size24Glyph } from '@hh.ru/magritte-ui-icon/variants/private/Diagram80Size24';
import { GripSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/private/GripSize16';
import { GripSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/private/GripSize24';
import { MetroLineSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/private/MetroLineSize16';
import { MetroLineSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/private/MetroLineSize24';
import { MetroStationSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/private/MetroStationSize16';
import { MetroStationSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/private/MetroStationSize24';
import { RadioCircleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/private/RadioCircleSize16';
import { RadioCircleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/private/RadioCircleSize24';
import { SkillPieAdvancedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/private/SkillPieAdvancedSize16';
import { SkillPieAdvancedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/private/SkillPieAdvancedSize24';
import { SkillPieBaseSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/private/SkillPieBaseSize16';
import { SkillPieBaseSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/private/SkillPieBaseSize24';
import { SkillPieMiddleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/private/SkillPieMiddleSize16';
import { SkillPieMiddleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/private/SkillPieMiddleSize24';

export const MetroLineSize24 = /* #__PURE__*/ hoc<'MetroLineSize24'>(MetroLineSize24Glyph, 'MetroLineSize24');
export const SkillPieAdvancedSize16 = /* #__PURE__*/ hoc<'SkillPieAdvancedSize16'>(
    SkillPieAdvancedSize16Glyph,
    'SkillPieAdvancedSize16'
);
export const Diagram60Size16 = /* #__PURE__*/ hoc<'Diagram60Size16'>(Diagram60Size16Glyph, 'Diagram60Size16');
export const Diagram100Size16 = /* #__PURE__*/ hoc<'Diagram100Size16'>(Diagram100Size16Glyph, 'Diagram100Size16');
export const Diagram75Size24 = /* #__PURE__*/ hoc<'Diagram75Size24'>(Diagram75Size24Glyph, 'Diagram75Size24');
export const SkillPieAdvancedSize24 = /* #__PURE__*/ hoc<'SkillPieAdvancedSize24'>(
    SkillPieAdvancedSize24Glyph,
    'SkillPieAdvancedSize24'
);
export const Diagram100Size24 = /* #__PURE__*/ hoc<'Diagram100Size24'>(Diagram100Size24Glyph, 'Diagram100Size24');
export const CheckboxLineSize16 = /* #__PURE__*/ hoc<'CheckboxLineSize16'>(
    CheckboxLineSize16Glyph,
    'CheckboxLineSize16'
);
export const CheckboxCheckSize16 = /* #__PURE__*/ hoc<'CheckboxCheckSize16'>(
    CheckboxCheckSize16Glyph,
    'CheckboxCheckSize16'
);
export const Diagram80Size16 = /* #__PURE__*/ hoc<'Diagram80Size16'>(Diagram80Size16Glyph, 'Diagram80Size16');
export const SkillPieBaseSize16 = /* #__PURE__*/ hoc<'SkillPieBaseSize16'>(
    SkillPieBaseSize16Glyph,
    'SkillPieBaseSize16'
);
export const CheckboxCheckSize24 = /* #__PURE__*/ hoc<'CheckboxCheckSize24'>(
    CheckboxCheckSize24Glyph,
    'CheckboxCheckSize24'
);
export const Diagram75Size16 = /* #__PURE__*/ hoc<'Diagram75Size16'>(Diagram75Size16Glyph, 'Diagram75Size16');
export const CheckboxLineSize24 = /* #__PURE__*/ hoc<'CheckboxLineSize24'>(
    CheckboxLineSize24Glyph,
    'CheckboxLineSize24'
);
export const SkillPieMiddleSize24 = /* #__PURE__*/ hoc<'SkillPieMiddleSize24'>(
    SkillPieMiddleSize24Glyph,
    'SkillPieMiddleSize24'
);
export const SkillPieMiddleSize16 = /* #__PURE__*/ hoc<'SkillPieMiddleSize16'>(
    SkillPieMiddleSize16Glyph,
    'SkillPieMiddleSize16'
);
export const SkillPieBaseSize24 = /* #__PURE__*/ hoc<'SkillPieBaseSize24'>(
    SkillPieBaseSize24Glyph,
    'SkillPieBaseSize24'
);
export const Diagram80Size24 = /* #__PURE__*/ hoc<'Diagram80Size24'>(Diagram80Size24Glyph, 'Diagram80Size24');
export const MetroLineSize16 = /* #__PURE__*/ hoc<'MetroLineSize16'>(MetroLineSize16Glyph, 'MetroLineSize16');
export const MetroStationSize16 = /* #__PURE__*/ hoc<'MetroStationSize16'>(
    MetroStationSize16Glyph,
    'MetroStationSize16'
);
export const MetroStationSize24 = /* #__PURE__*/ hoc<'MetroStationSize24'>(
    MetroStationSize24Glyph,
    'MetroStationSize24'
);
export const RadioCircleSize16 = /* #__PURE__*/ hoc<'RadioCircleSize16'>(RadioCircleSize16Glyph, 'RadioCircleSize16');
export const Diagram60Size24 = /* #__PURE__*/ hoc<'Diagram60Size24'>(Diagram60Size24Glyph, 'Diagram60Size24');
export const RadioCircleSize24 = /* #__PURE__*/ hoc<'RadioCircleSize24'>(RadioCircleSize24Glyph, 'RadioCircleSize24');
export const GripSize16 = /* #__PURE__*/ hoc<'GripSize16'>(GripSize16Glyph, 'GripSize16');
export const GripSize24 = /* #__PURE__*/ hoc<'GripSize24'>(GripSize24Glyph, 'GripSize24');
